import { graphql } from '@/generated/graphql';

export const INSERT_ORDER_COMMENT = graphql(`
  mutation InsertOrderComment($orderId: Int!, $authorId: String!, $comment: String!) {
    insert_order_comments_one(
      object: { orderId: $orderId, source: "dtk_admin", authorId: $authorId, comment: $comment }
    ) {
      id
      orderId
    }
  }
`);

export const EDIT_ORDER_POSITIONS = graphql(`
  mutation EditOrder(
    $orderID: Int!
    $umbrellaID: String!
    $orderItems: [OrderItemInput!]!
  ) {
    editOrder(
      orderID: $orderID
      umbrellaID: $umbrellaID
      orderItems: $orderItems
    ) {
      orderItems
      deliveryPrice
    }
  }
`);

export const UPDATE_ORDER_VIA_ACTION = graphql(`
  mutation UpdateOrderViaAction(
    $orderId: Int!
    $order: OrderPatch
    $client: ClientPatch
    $address: AddressPatch
  ) {
    updateOrder(
      orderId: $orderId
      order: $order
      client: $client
      address: $address
    ) {
      applied
    }
  }
`);

export const CALC_ORDER_PRICE = graphql(`
  query CalcOrderPrice(
    $orderID: Int!
    $umbrellaID: String!
    $orderItems: [OrderItemInput!]!
  ) {
    recalcOrder(
      orderID: $orderID
      umbrellaID: $umbrellaID
      orderItems: $orderItems
    ) {
      orderItems
      deliveryPrice
    }
  }
`);

export const INSERT_USER_VIEWS_LOG = graphql(`
  mutation InsertUserViewsLog($userId: String!, $orderId: Int) {
    insert_user_views_log(objects: { orderId: $orderId, userId: $userId }) {
      affected_rows
    }
  }
`);
